import { useRef, useState } from 'react';

/**
 * O comportamento de salvamento de todo formulário do Hub.
 *
 * **Duas guardas, e elas protegem coisas diferentes:**
 *
 * 1. **Confirmar ao salvar** — pedido do Richard em 14/08/2026. Clicar em
 *    Salvar abre uma pergunta; só o "Sim" grava.
 * 2. **Avisar ao fechar com alteração pendente** — a proteção que o dia a dia
 *    cobra de verdade. Salvar por engano é raro; fechar a janela e perder dez
 *    minutos de digitação acontece toda semana.
 *
 * O "sujo" sai da comparação do estado atual com o de quando o formulário
 * abriu. Fechar sem ter tocado em nada não pergunta nada — perguntar por
 * perguntar ensina a pessoa a clicar "sim" sem ler, e aí a guarda deixa de
 * proteger.
 */
export type Pendencia = 'salvar' | 'descartar' | null;

export function usarFormulario<T>(valores: T, aoFecharDeVerdade: () => void) {
  const inicial = useRef(JSON.stringify(valores));
  const [pendencia, setPendencia] = useState<Pendencia>(null);

  const sujo = JSON.stringify(valores) !== inicial.current;

  /** Chame no lugar de `aoFechar` em botões, Esc e clique fora. */
  function fechar(): void {
    if (sujo) return setPendencia('descartar');
    aoFecharDeVerdade();
  }

  /** Chame depois de validar, no lugar de gravar direto. */
  function pedirParaSalvar(): void {
    setPendencia('salvar');
  }

  function cancelarPendencia(): void {
    setPendencia(null);
  }

  /** Depois de gravar com sucesso, para o formulário não se achar sujo. */
  function marcarComoSalvo(novos: T): void {
    inicial.current = JSON.stringify(novos);
  }

  return { sujo, pendencia, fechar, pedirParaSalvar, cancelarPendencia, marcarComoSalvo, aoFecharDeVerdade };
}
